import React, { useState } from 'react';

const curriculum = [
  {
    title: 'Introduction',
    emoji: '🎬',
    lectures: 3,
    duration: '18 min',
    lessons: [
      { title: 'Course Introduction', duration: '3:08', preview: true, youtube: 'https://www.youtube.com/embed/i7twT3x5yv8' },
      { title: 'How this course is structured?', duration: '3:08', preview: true, youtube: 'https://www.youtube.com/embed/i7twT3x5yv8' },
      { title: 'Framework for System Design Interviews', duration: '12:14', preview: true, youtube: 'https://www.youtube.com/embed/i7twT3x5yv8' },
    ]
  },
  {
    title: 'Instagram Newsfeed',
    emoji: '📱',
    lectures: 33,
    duration: '1h 20min',
    lessons: [
      { title: 'Deciding Requirements — Functional Requirements', duration: '1:12', preview: true, youtube: 'https://www.youtube.com/embed/9-hjBGxuiEs' },
      { title: 'Deciding Requirements — Non-Functional Requirements', duration: '2:01', preview: false },
      { title: 'Capacity Estimation — Introduction', duration: '0:30', preview: false },
      { title: 'Capacity Estimation — Why should you do it?', duration: '4:34', preview: false },
      { title: 'Capacity Estimation — DAU/MAU', duration: '0:27', preview: false },
      { title: 'Capacity Estimation — Throughput', duration: '2:45', preview: false },
      { title: 'Capacity Estimation — Storage', duration: '2:03', preview: false, type: 'quiz' },
      { title: 'Capacity Estimation — Memory & Network Bandwidth', duration: '2:43', preview: false },
      { title: 'API Design — Create a Text Post', duration: '2:03', preview: false },
      { title: 'API Design — Create an Image / Video Post', duration: '2:27', preview: false },
      { title: 'API Design — Like / Comment on a Post', duration: '1:28', preview: false },
      { title: 'API Design — Follow / Unfollow another User', duration: '1:14', preview: false },
      { title: 'API Design — Read the NewsFeed (aka Timeline)', duration: '1:20', preview: false },
      { title: 'High Level Design — Follow / Unfollow', duration: '1:44', preview: false },
      { title: 'High Level Design — Create a Text Post', duration: '2:59', preview: false },
      { title: 'High Level Design — Create an Image / Video Post', duration: '3:59', preview: false },
      { title: 'High Level Design — Read the NewsFeed', duration: '1:48', preview: false },
      { title: 'High Level Design — Comment & Like on a Post', duration: '1:53', preview: false },
      { title: 'Deep Dive — Database Selection', duration: '4:48', preview: false },
      { title: 'Deep Dive — Data Modeling', duration: '4:07', preview: false },
      { title: 'Deep Dive — Pre-Signed URLs', duration: '1:38', preview: false },
      { title: 'Deep Dive — Media Processing', duration: '1:31', preview: false },
      { title: 'Celebrity Accounts', duration: '', preview: false, type: 'quiz' },
    ]
  },
  {
    title: 'YouTube / Netflix',
    emoji: '🎬',
    lectures: 18,
    duration: '42 min',
    lessons: [
      { title: 'Deciding Requirements — Functional Requirements', duration: '0:53', preview: true, youtube: 'https://www.youtube.com/embed/jainl6nn_5Y' },
      { title: 'Deciding Requirements — Non-Functional Requirements', duration: '2:02', preview: false },
      { title: 'Capacity Estimation — Throughput & Storage', duration: '2:56', preview: false },
      { title: 'API Design — Upload Content', duration: '5:06', preview: false },
      { title: 'API Design — Stream Content', duration: '4:11', preview: false },
      { title: 'Streaming vs Downloading', duration: '', preview: false, type: 'quiz' },
      { title: 'High Level Design — Upload Content', duration: '1:17', preview: false },
      { title: 'High Level Design — Content Processor Workflow Engine', duration: '5:41', preview: false },
      { title: 'High Level Design — Stream Content', duration: '2:43', preview: false },
      { title: 'Deep Dive — Database Selection', duration: '2:28', preview: false },
      { title: 'Deep Dive — Data Modeling', duration: '1:49', preview: false },
      { title: 'Deep Dive — HLS Encoding', duration: '2:05', preview: false },
    ]
  },
  {
    title: 'TinyURL',
    emoji: '🔗',
    lectures: 26,
    duration: '42 min',
    lessons: [
      { title: 'Introduction — What is a Tiny URL Service?', duration: '0:40', preview: true, youtube: 'https://www.youtube.com/embed/JQDHz72LtRQ' },
      { title: 'Introduction — Why do we need a Tiny URL Service?', duration: '1:01', preview: true, youtube: 'https://www.youtube.com/embed/JQDHz72LtRQ' },
      { title: 'Deciding Requirements — Functional & Non-Functional', duration: '1:15', preview: false },
      { title: 'Capacity Estimation — Throughput, Storage & Memory', duration: '1:47', preview: false },
      { title: 'API Design — Generate a Short URL', duration: '2:08', preview: false },
      { title: 'API Design — Get Long URL back', duration: '1:10', preview: false },
      { title: 'URL Redirections', duration: '', preview: false, type: 'quiz' },
      { title: 'High Level Design — Generate Short URL', duration: '1:36', preview: false },
      { title: 'High Level Design — Problem: Collisions', duration: '1:17', preview: false },
      { title: 'HLD — Approach 1: Random String Generation', duration: '1:15', preview: false },
      { title: 'HLD — Approach 2: Random String from LongURL', duration: '1:49', preview: false },
      { title: 'HLD — Approach 3: Check DB for Collisions', duration: '2:29', preview: false },
      { title: 'HLD — Approach 4: Keep Counters + Zookeeper', duration: '2:23', preview: false },
      { title: 'HLD — Approach 4: Base 62 Encoding', duration: '4:31', preview: false },
      { title: 'HLD — Approach 4: Final Design Diagram', duration: '1:56', preview: false },
      { title: 'Deep Dive — Database Selection & Data Modeling', duration: '1:53', preview: false },
      { title: 'Deep Dive — Redirection from Short URL', duration: '1:50', preview: false },
      { title: 'Predictable Short URLs', duration: '', preview: false, type: 'quiz' },
    ]
  },
  {
    title: 'Rate Limiter',
    emoji: '⚡',
    lectures: 23,
    duration: '1h 04min',
    lessons: [
      { title: 'Introduction — Analogy & What is a Rate Limiter?', duration: '1:35', preview: true, youtube: 'https://www.youtube.com/embed/FU4WlwfS3G0' },
      { title: 'Introduction — Why do we need a Rate Limiter?', duration: '1:10', preview: false },
      { title: 'Deciding Requirements — Functional & Non-Functional', duration: '1:26', preview: false },
      { title: 'Capacity Estimation — Storage, Memory & Bandwidth', duration: '3:06', preview: false },
      { title: 'High Level Design — Placement of Rate Limiter', duration: '4:01', preview: false },
      { title: 'High Level Design — Basic Flow & Storing Counters', duration: '2:02', preview: false },
      { title: 'High Level Design — Storing Rate Limiter Rules', duration: '2:36', preview: false },
      { title: 'Deep Dive — Token Bucket Algorithm', duration: '8:23', preview: false },
      { title: 'Deep Dive — Leaky Bucket Algorithm', duration: '7:10', preview: false },
      { title: 'Deep Dive — Fixed Window Counter Algorithm', duration: '4:53', preview: false },
      { title: 'Deep Dive — Sliding Window Log Algorithm', duration: '8:50', preview: false },
      { title: 'Deep Dive — Sliding Window Counter Algorithm', duration: '7:31', preview: false },
      { title: 'Deep Dive — Handling Race Conditions', duration: '3:13', preview: false },
    ]
  },
  {
    title: 'WhatsApp',
    emoji: '💬',
    lectures: 27,
    duration: '1h 16min',
    lessons: [
      { title: 'Deciding Requirements — Functional Requirements', duration: '1:29', preview: true, youtube: 'https://www.youtube.com/embed/vvhC64hQZMk' },
      { title: 'Deciding Requirements — Non-Functional Requirements', duration: '0:57', preview: false },
      { title: 'Capacity Estimation — Throughput & Storage', duration: '3:01', preview: false },
      { title: 'API Design — 1:1 Messaging', duration: '4:43', preview: false },
      { title: 'API Design — Message Status', duration: '1:33', preview: false },
      { title: 'API Design — Online Status', duration: '2:53', preview: false },
      { title: 'API Design — Group Messages', duration: '1:53', preview: false },
      { title: 'HLD — How is WebSocket Connection established?', duration: '4:50', preview: false },
      { title: 'HLD — 1:1 Messaging & Offline Client', duration: '3:27', preview: false },
      { title: 'HLD — 1:1 Messaging: Images, Videos & Documents', duration: '4:05', preview: false },
      { title: 'HLD — Message Status', duration: '5:31', preview: false },
      { title: 'HLD — Online Status', duration: '2:46', preview: false },
      { title: 'HLD — Group Messages', duration: '3:05', preview: false },
      { title: 'Deep Dive — Database Selection & Data Modeling', duration: '4:16', preview: false },
      { title: 'Deep Dive — End to End Encryption', duration: '2:11', preview: false },
    ]
  },
  {
    title: 'Search Systems',
    emoji: '🔍',
    lectures: 18,
    duration: '55 min',
    lessons: [
      { title: 'Deciding Requirements — Functional Requirements', duration: '2:44', preview: true, youtube: 'https://www.youtube.com/embed/0LTXCcVRQi0' },
      { title: 'Deciding Requirements — Non-Functional Requirements', duration: '4:46', preview: false },
      { title: 'Capacity Estimation — DAU/MAU, Throughput & Storage', duration: '2:43', preview: false },
      { title: 'API Design — Search', duration: '3:03', preview: false },
      { title: 'High Level Design — Search (Suboptimal)', duration: '2:48', preview: false },
      { title: 'High Level Design — Search (Indexing)', duration: '2:50', preview: false },
      { title: 'High Level Design — How to Support Fuzzy Search?', duration: '3:21', preview: false },
      { title: 'High Level Design — Search (Ranking)', duration: '4:18', preview: false },
      { title: 'High Level Design — Search (Final Design)', duration: '4:14', preview: false },
      { title: 'Deep Dive — Database Selection', duration: '5:42', preview: false },
      { title: 'Deep Dive — Data Modeling', duration: '3:32', preview: false },
      { title: 'Deep Dive — Query Correction Service', duration: '5:01', preview: false },
      { title: 'Deep Dive — Elastic Search', duration: '1:52', preview: false },
    ]
  },
  {
    title: 'Airbnb',
    emoji: '🏠',
    lectures: 18,
    duration: '50 min',
    lessons: [
      { title: 'Deciding Requirements — Functional Requirements', duration: '1:42', preview: true, youtube: 'https://www.youtube.com/embed/YyOXt2MEkv4' },
      { title: 'Deciding Requirements — Non-Functional Requirements', duration: '1:09', preview: false },
      { title: 'Capacity Estimation — Throughput, Storage & Memory', duration: '3:39', preview: false },
      { title: 'API Design — Add Property (Property Owner)', duration: '2:23', preview: false },
      { title: 'API Design — View Bookings (Property Owner)', duration: '2:33', preview: false },
      { title: 'API Design — Search Properties (Guest)', duration: '2:18', preview: false },
      { title: 'API Design — View Property (Guest)', duration: '1:48', preview: false },
      { title: 'API Design — Book Property (Guest)', duration: '6:19', preview: false },
      { title: 'HLD — Add / Update Property', duration: '4:57', preview: false },
      { title: 'HLD — Search Properties', duration: '4:57', preview: false },
      { title: 'HLD — View Property & Book Property', duration: '3:45', preview: false },
      { title: 'Deep Dive — Database Selection & Data Modeling', duration: '3:11', preview: false },
      { title: 'Deep Dive — Handling Concurrent Bookings', duration: '6:36', preview: false },
    ]
  },
  {
    title: 'Notification System',
    emoji: '🔔',
    lectures: 19,
    duration: '1h 01min',
    lessons: [
      { title: 'Introduction — What is a Notification System?', duration: '1:35', preview: true, youtube: 'https://www.youtube.com/embed/bBTPZ9NdSk8' },
      { title: 'Introduction — Why do we need a Notification System?', duration: '2:08', preview: false },
      { title: 'Deciding Requirements — Functional & Non-Functional', duration: '5:35', preview: false },
      { title: 'Capacity Estimation — DAU/MAU, Throughput & Storage', duration: '3:31', preview: false },
      { title: 'API Design — Send Notification', duration: '3:29', preview: false },
      { title: 'High Level Design — Basic High Level Flow', duration: '10:20', preview: false },
      { title: 'HLD — Problems with Basic Design', duration: '4:12', preview: false },
      { title: 'HLD — Validation and Prioritization', duration: '1:54', preview: false },
      { title: 'HLD — Rate Limiting Notifications', duration: '1:15', preview: false },
      { title: 'HLD — Adjusting to User Preferences', duration: '2:55', preview: false },
      { title: 'HLD — Handling Different Types of Notifications', duration: '4:31', preview: false },
      { title: 'HLD — Reorganizing & Decoupling Services', duration: '5:39', preview: false },
      { title: 'Deep Dive — Database Selection & Data Modeling', duration: '2:56', preview: false },
    ]
  },
  {
    title: 'Distributed Logging System',
    emoji: '📋',
    lectures: 12,
    duration: '32 min',
    lessons: [
      { title: 'Introduction', duration: '3:47', preview: true, youtube: 'https://www.youtube.com/embed/I8LucBJFj9U' },
      { title: 'Deciding Requirements — Functional & Non-Functional', duration: '3:36', preview: false },
      { title: 'HLD — Client Request and Correlation ID', duration: '1:15', preview: false },
      { title: 'HLD — Collecting Logs on each Service', duration: '2:08', preview: false },
      { title: 'HLD — Kafka for Buffering', duration: '2:19', preview: false },
      { title: 'HLD — Processing with Flink', duration: '4:14', preview: false },
      { title: 'HLD — Storage Backends', duration: '5:21', preview: false },
      { title: 'HLD — Query and Dashboards', duration: '3:47', preview: false },
      { title: 'Deep Dive — Protobuf & Avro Serialization', duration: '3:59', preview: false },
      { title: 'Deep Dive — Flink Deep Dive', duration: '4:51', preview: false },
    ]
  },
  {
    title: 'Core Building Blocks',
    emoji: '🧱',
    lectures: 12,
    duration: '20 min',
    lessons: [
      { title: 'Client & Server', duration: '1:40', preview: true, youtube: 'https://www.youtube.com/embed/L5BlpPU_muY' },
      { title: 'Database', duration: '2:47', preview: true, youtube: 'https://www.youtube.com/embed/L5BlpPU_muY' },
      { title: 'Vertical vs Horizontal Scaling', duration: '1:57', preview: false },
      { title: 'Load Balancer', duration: '1:42', preview: false },
      { title: 'Database Sharding', duration: '1:14', preview: false },
      { title: 'Database Replication', duration: '0:59', preview: false },
      { title: 'Cache', duration: '1:45', preview: false },
      { title: 'Content Delivery Network (CDN)', duration: '1:49', preview: false },
      { title: 'Monolith & Microservice', duration: '1:31', preview: false },
      { title: 'Message Queue', duration: '1:38', preview: false },
      { title: 'API Gateway', duration: '0:59', preview: false },
    ]
  },
  {
    title: 'System Design Concepts',
    emoji: '⚙️',
    lectures: 14,
    duration: '19 min',
    lessons: [
      { title: 'Scalability', duration: '1:22', preview: false },
      { title: 'Availability', duration: '0:59', preview: false },
      { title: 'Consistency — Strong / Eventual', duration: '2:38', preview: false },
      { title: 'Fault Tolerance / No SPOF', duration: '1:43', preview: false },
      { title: 'IP Address', duration: '1:31', preview: false },
      { title: 'DNS — Domain Name Service', duration: '1:30', preview: false },
      { title: 'Protocols — TCP, UDP, HTTP, Websocket', duration: '1:24', preview: false },
      { title: 'Forward Proxy & Reverse Proxy', duration: '2:05', preview: false },
    ]
  },
  {
    title: 'API Types',
    emoji: '🔌',
    lectures: 6,
    duration: '9 min',
    lessons: [
      { title: 'Introduction', duration: '0:47', preview: false },
      { title: 'GraphQL', duration: '1:41', preview: false },
      { title: 'gRPC', duration: '1:43', preview: false },
      { title: 'Message Queues', duration: '2:18', preview: false },
      { title: 'REST API', duration: '1:04', preview: false },
    ]
  },
  {
    title: 'Databases',
    emoji: '🗄️',
    lectures: 7,
    duration: '14 min',
    lessons: [
      { title: 'Relational Database / SQL', duration: '1:28', preview: false },
      { title: 'Non-Relational Database / NoSQL', duration: '3:03', preview: false },
      { title: 'SQL vs NoSQL', duration: '3:02', preview: false },
      { title: 'Object Storage', duration: '0:57', preview: false },
      { title: 'Cache', duration: '2:18', preview: false },
      { title: 'CDN — Content Delivery Network', duration: '1:35', preview: false },
    ]
  },
  {
    title: 'Caching Strategies',
    emoji: '🚀',
    lectures: 6,
    duration: '18 min',
    lessons: [
      { title: 'Read Caching Strategies', duration: '3:17', preview: false },
      { title: 'Write Caching Strategies', duration: '2:19', preview: false },
      { title: 'Read Cache Strategies — Pros and Cons', duration: '4:23', preview: false },
      { title: 'Write Cache Strategies — Pros and Cons', duration: '6:32', preview: false },
    ]
  },
  {
    title: 'Advanced Topics & Bonus',
    emoji: '🏆',
    lectures: 11,
    duration: '55 min',
    lessons: [
      { title: 'Cloud Computing', duration: '4:20', preview: false },
      { title: 'Logging & Monitoring', duration: '3:28', preview: false },
      { title: 'Hashing & Consistent Hashing', duration: '1:19', preview: false },
      { title: 'CAP Theorem', duration: '0:42', preview: false },
      { title: 'Database Indexing', duration: '11:28', preview: false },
      { title: 'Apache Kafka — Event Streaming Deep Dive', duration: '7:23', preview: false },
      { title: 'Beginners Guide to GraphQL', duration: '15:56', preview: false },
      { title: 'Consistent Hashing — Deep Dive', duration: '', preview: false },
    ]
  },
];

const PlayIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="7.5" r="6.75" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M6 5L10.5 7.5L6 10V5Z" fill="currentColor"/>
  </svg>
);

const QuizIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M4.5 5.5h6M4.5 8h4" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);

const LockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="5.5" width="9" height="6.5" rx="1.5" stroke="currentColor" strokeWidth="1.1"/>
    <path d="M4 5.5V4a2.5 2.5 0 015 0v1.5" stroke="currentColor" strokeWidth="1.1"/>
  </svg>
);

const ChevronIcon = ({ open }) => (
  <svg
    width="16" height="16" viewBox="0 0 16 16" fill="none"
    style={{ transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
  >
    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const VISIBLE_DEFAULT = 5; // how many sections to show before "show more"

const CourseCurriculum = () => {
  const [expandedSections, setExpandedSections] = useState({ 0: true });
  const [activeVideo, setActiveVideo] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const visibleCurriculum = showAll ? curriculum : curriculum.slice(0, VISIBLE_DEFAULT);

  const toggleSection = (i) => {
    setExpandedSections(prev => ({ ...prev, [i]: !prev[i] }));
  };

  const toggleVideo = (key) => {
    setActiveVideo(prev => prev === key ? null : key);
  };

  return (
    <section className="cc-section" id="curriculum">
      <div className="cc-container">
        {/* Header */}
        <div className="cc-header">
          <span className="cc-label">Course Content</span>
          <h2 className="cc-title">
            Everything You Need To <span className="cc-accent">Ace</span> System Design Interviews
          </h2>
          <p className="cc-subtitle">
            Structured Learning Path — From Fundamentals To Live Mock Interviews
          </p>
        </div>

        {/* Stats Bar */}
        <div className="cc-stats-bar">
          <div className="cc-stat">
            <span className="cc-stat-num">18</span>
            <span className="cc-stat-label">Sections</span>
          </div>
          <div className="cc-stat-divider" />
          <div className="cc-stat">
            <span className="cc-stat-num">230</span>
            <span className="cc-stat-label">Lectures</span>
          </div>
          <div className="cc-stat-divider" />
          <div className="cc-stat">
            <span className="cc-stat-num">10h 39m</span>
            <span className="cc-stat-label">Total length</span>
          </div>
          <div className="cc-stat-divider" />
          <div className="cc-stat">
            <span className="cc-stat-num">10</span>
            <span className="cc-stat-label">Real-world problems</span>
          </div>
        </div>

        {/* Accordion */}
        <div className="cc-accordion">
          {visibleCurriculum.map((section, si) => {
            const isOpen = !!expandedSections[si];
            return (
              <div key={si} className={`cc-module ${isOpen ? 'cc-module--open' : ''}`}>
                <button className="cc-module-header" onClick={() => toggleSection(si)}>
                  <span className="cc-module-num">{String(si + 1).padStart(2, '0')}</span>
                  <span className="cc-module-emoji">{section.emoji}</span>
                  <span className="cc-module-title">{section.title}</span>
                  <span className="cc-module-meta">
                    <span>{section.lectures} lectures</span>
                    <span className="cc-meta-dot">·</span>
                    <span>{section.duration}</span>
                  </span>
                  <span className="cc-chevron">
                    <ChevronIcon open={isOpen} />
                  </span>
                </button>

                {isOpen && (
                  <div className="cc-lessons">
                    {section.lessons.map((lesson, li) => {
                      const videoKey = `${si}-${li}`;
                      const isVideoOpen = activeVideo === videoKey;
                      const isLocked = !lesson.preview;

                      return (
                        <React.Fragment key={li}>
                          <div className={`cc-lesson ${isLocked ? 'cc-lesson--locked' : 'cc-lesson--free'}`}>
                            <span className="cc-lesson-icon">
                              {lesson.type === 'quiz' ? <QuizIcon /> : <PlayIcon />}
                            </span>
                            <span className="cc-lesson-title">{lesson.title}</span>
                            <span className="cc-lesson-right">
                              {lesson.preview ? (
                                <button
                                  className={`cc-preview-btn ${isVideoOpen ? 'cc-preview-btn--active' : ''}`}
                                  onClick={() => toggleVideo(videoKey)}
                                >
                                  {isVideoOpen ? '✕ Close' : '▶ Preview'}
                                </button>
                              ) : (
                                <span className="cc-lock-icon"><LockIcon /></span>
                              )}
                              <span className="cc-lesson-dur">{lesson.duration}</span>
                            </span>
                          </div>

                          {/* Inline Video Player */}
                          {lesson.preview && lesson.youtube && isVideoOpen && (
                            <div className="cc-video-panel">
                              <div className="cc-video-inner">
                                <div className="cc-video-wrap">
                                  <iframe
                                    src={`${lesson.youtube}?autoplay=1&rel=0`}
                                    title={lesson.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                  />
                                </div>
                                <button className="cc-video-close" onClick={() => toggleVideo(videoKey)}>
                                  ✕ Close preview
                                </button>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Show more / less toggle */}
        <div className="cc-show-more">
          <button className="cc-show-more-btn" onClick={() => setShowAll(v => !v)}>
            {showAll
              ? <>↑ Show less</>
              : <>{`＋ Show all ${curriculum.length} sections (${curriculum.length - VISIBLE_DEFAULT} more)`}</>
            }
          </button>
        </div>

        {/* Bottom CTA */}
        <div className="cc-cta-block">
          <div className="cc-cta-teaser">
            <span className="cc-cta-lock">🔒</span>
            <span>200+ more lectures across 10 real-world systems — unlock the full 10h 39m course</span>
          </div>
          <a href="#enroll" className="cc-cta-btn">
            Get Full Access — <span className="cc-price-inr">₹499</span>
            <span className="cc-price-sep"> / </span>
            <span className="cc-price-usd">$49</span>
          </a>
          <p className="cc-cta-sub">Lifetime access&nbsp;•&nbsp;Certificate included&nbsp;•&nbsp;30-day money back guarantee</p>
        </div>
      </div>
    </section>
  );
};

export default CourseCurriculum;
